<template>
  <div class="animated fadeIn">
    <b-row>
      <PageTitle></PageTitle>
      <b-col lg="4">
        <resume-card :counter="models.toString()" :subject="$tc('title.models', 0)" link="models" title="Vai all'elenco dei modelli" icon="far fa-file-invoice"/>
      </b-col>
      <b-col lg="4">
        <resume-card :counter="profiles.toString()" :subject="$tc('title.profiles', 0)" link="profiles" title="Vai all'elenco dei profili" icon="far fa-h1"/>
      </b-col>
      <b-col lg="4">
        <resume-card :counter="documentType.toString()" :subject="$tc('title.documentType', 0)" link="doctype" title="Vai all'elenco delle documentType" icon="far fa-file-code"/>
      </b-col>
      <b-col lg="4">
        <resume-card :counter="procedureAndPatientDetails.toString()" :subject="$tc('title.ppd', 0)" link="patientAndProcedureDetails" title="Vai all'elenco del dizionario Patient & Procedure Details" icon="far fa-user-md"/>
      </b-col>
      <b-col lg="4">
        <resume-card :counter="patientConstraints.toString()" :subject="$tc('title.patientConstraint', 0)" link="patientConstraint" title="Vai all'elenco del dizionario Patient Constraint" icon="far fa-tasks"/>
      </b-col>
      <b-col lg="4">
        <resume-card :counter="companies.toString()" :subject="$tc('title.companies', 0)" link="company" title="Vai all'elenco delle aziende" icon="far fa-hospital-alt"/>
      </b-col>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 id="traffic" class="card-title mb-0">Modelli generati</h4>
              <div class="small text-muted">{{ $t('page.chart.description', {n: chartData.dataFrom, m: chartData.dataTo} ) }}, per un totale dall'avvio dell'impianto di {{ generatedDocumentTotal }} modelli generati</div>
            </b-col>
          </b-row>
          <model-chart v-if="loaded" chartId="main-chart-01" class="chart-wrapper" style="height:300px; margin-top:40px;" :label="chartData.label" :data="chartData.data"></model-chart>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ModelChart from '../components/dashboard/ModelChart'
  import ResumeCard from '../components/dashboard/ResumeCard'
  import PageTitle from '../components/PageTitle'
  import moment from 'moment'
  import DashboardService from "@/services/DashboardService";

  const dashboardService = DashboardService.build();

  export default {
    name: 'dashboard',
    components: {
      ModelChart,
      PageTitle,
      ResumeCard
    },
    data: function () {
      return {
        models: 0,
        profiles: 0,
        generatedDocumentTotal: 0,
        documentType: 0,
        procedureAndPatientDetails: 0,
        patientConstraints: 0,
        companies: 0,
        loaded: false,
        chartData: {
          dataFrom: null,
          dataTo: null,
          data: [],
          label: []
        }
      };
    },
    async mounted() {
      this.getModelOnline();
      this.getActiveProfile();
      this.getGeneratedDocument();
      this.getDocumentType();
      this.getProcedureAndPatientDetails();
      this.getPatientConstraints();
      this.getCompanies();
      this.getStatistics();
    },
    methods: {

      async getStatistics() {
        this.loaded = false;
        let response = await dashboardService.statistics();
        this.chartData.data = response.data.map( e => e[0]);
        this.chartData.dataFrom = moment(response.from).format('DD/MM');
        this.chartData.dataTo = moment(response.to).format('DD/MM');
        this.chartData.label = response.data.map( e => moment(e[1]));
        this.loaded = true;
      },

      async getModelOnline() {
        let response = await dashboardService.modelsList();
        this.models = response.total;
      },

      async getActiveProfile() {
        let response = await dashboardService.profilesList();
        this.profiles = response.total;
      },

      async getDocumentType() {
        let response = await dashboardService.documentTypeList();
        this.documentType = response.total;
      },

      async getProcedureAndPatientDetails() {
        let response = await dashboardService.procedureAndPatientDetailList();
        this.procedureAndPatientDetails = response.total;
      },

      async getPatientConstraints() {
        let response = await dashboardService.patientConstraintList();
        this.patientConstraints = response.total;
      },

      async getCompanies() {
        let response = await dashboardService.companyList();
        this.companies = response.total;
      },
      async getGeneratedDocument() {
        let response = await dashboardService.generatedDocumentCount();
        this.generatedDocumentTotal = response || 0;
      }
    }
  }
</script>

<style scoped>
  /* IE fix */
  #modelChart {
    width: 100% !important;
  }
</style>
